import {Component, HostListener} from '@angular/core';
import { environment } from 'environments/environment';

@Component({
    selector: 'top-nav-bar',
    templateUrl: 'top-nav-bar.component.html',
    styleUrls: ['top-nav-bar.component.scss']
})

export class TopNavBarComponent {

    showAdContainer: boolean = true;
    prodEnvironment: boolean = false;

    constructor() {
        this.updateShowAdContainer();
        this.prodEnvironment =  environment.production;
    }


    isMobile(): boolean {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }

    updateShowAdContainer(): void {
        this.showAdContainer = window.innerWidth > 768;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
       this.updateShowAdContainer();
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/top-nav-bar/top-nav-bar.component.ts